import { createListFilters } from '../../../../../components'

export type CoordenadoresFilters = {
  /** Busca local por nome, número do conselho ou RQE (a lista vem inteira do empregador). */
  busca: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<CoordenadoresFilters>({
  busca: '',
})
